import React, { PropTypes } from "react";

import { BlocClientsLineItem } from "./";

class RenderLineItems extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.clients
      .sort((a, b) => {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      })
      .map((client) => {
        this.props.fields.push(client);
      });
  }

  componentWillReceiveProps(nextProps) {
    nextProps.fields.removeAll();
    nextProps.clients.forEach((client, index) => {
      if (nextProps.formValues[nextProps.name]) {
        const match = nextProps.formValues[nextProps.name].find((split) => {
          return split.clientId === client.clientId;
        });
        if (match) {
          nextProps.fields.push({ ...match, order: index + 1 });
        } else {
          nextProps.fields.push({
            ...client,
            order: index + 1,
          });
        }
      } else {
        nextProps.fields.push({
          ...client,
          order: index + 1,
        });
      }
    });
  }

  render() {
    const {
      disabled,
      id,
      blocId,
      fields,
      formValues,
      removeClient,
      moveClient,
    } = this.props;

    const name = fields.name;

    return (
      <div>
        {fields.map((split, index) => {
          if (formValues[name][index]) {
            return (
              <BlocClientsLineItem
                key={index}
                index={index}
                disabled={disabled}
                listId={id}
                blocId={blocId}
                client={formValues[name][index]}
                removeClient={removeClient}
                moveClient={moveClient}
              />
            );
          }
          return <div key={index} />;
        })}
      </div>
    );
  }
}

RenderLineItems.propTypes = {
  clients: PropTypes.array,
  disabled: PropTypes.bool,
  fields: PropTypes.object,
  formValues: PropTypes.object,
  blocId: PropTypes.string,
  id: PropTypes.string,
  moveClient: PropTypes.func,
  name: PropTypes.string,
  removeClient: PropTypes.func,
};

export default RenderLineItems;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/clients/RenderLineItems.js